"use strict";

var _objectSpread = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _slicedToArray = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var cov_7ibe2bkbp = function () {
  var path = "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/repository/withRepository.js";
  var hash = "a6af38ee6a74acfca5fc52b67fe3b91158ec262f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/repository/withRepository.js",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 74,
          column: 3
        }
      },
      "1": {
        start: {
          line: 15,
          column: 28
        },
        end: {
          line: 15,
          column: 48
        }
      },
      "2": {
        start: {
          line: 17,
          column: 31
        },
        end: {
          line: 17,
          column: 36
        }
      },
      "3": {
        start: {
          line: 18,
          column: 27
        },
        end: {
          line: 18,
          column: 29
        }
      },
      "4": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 22,
          column: 5
        }
      },
      "5": {
        start: {
          line: 20,
          column: 76
        },
        end: {
          line: 20,
          column: 98
        }
      },
      "6": {
        start: {
          line: 21,
          column: 6
        },
        end: {
          line: 21,
          column: 84
        }
      },
      "7": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 25,
          column: 5
        }
      },
      "8": {
        start: {
          line: 24,
          column: 6
        },
        end: {
          line: 24,
          column: 89
        }
      },
      "9": {
        start: {
          line: 32,
          column: 8
        },
        end: {
          line: 32,
          column: 24
        }
      },
      "10": {
        start: {
          line: 34,
          column: 26
        },
        end: {
          line: 34,
          column: 85
        }
      },
      "11": {
        start: {
          line: 34,
          column: 33
        },
        end: {
          line: 34,
          column: 84
        }
      },
      "12": {
        start: {
          line: 36,
          column: 29
        },
        end: {
          line: 44,
          column: 5
        }
      },
      "13": {
        start: {
          line: 38,
          column: 6
        },
        end: {
          line: 41,
          column: 7
        }
      },
      "14": {
        start: {
          line: 39,
          column: 8
        },
        end: {
          line: 39,
          column: 30
        }
      },
      "15": {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 40,
          column: 100
        }
      },
      "16": {
        start: {
          line: 42,
          column: 6
        },
        end: {
          line: 43,
          column: 27
        }
      },
      "17": {
        start: {
          line: 42,
          column: 24
        },
        end: {
          line: 42,
          column: 45
        }
      },
      "18": {
        start: {
          line: 43,
          column: 11
        },
        end: {
          line: 43,
          column: 27
        }
      },
      "19": {
        start: {
          line: 46,
          column: 20
        },
        end: {
          line: 46,
          column: 27
        }
      },
      "20": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 67,
          column: 5
        }
      },
      "21": {
        start: {
          line: 48,
          column: 6
        },
        end: {
          line: 55,
          column: 8
        }
      },
      "22": {
        start: {
          line: 56,
          column: 11
        },
        end: {
          line: 67,
          column: 5
        }
      },
      "23": {
        start: {
          line: 58,
          column: 6
        },
        end: {
          line: 58,
          column: 66
        }
      },
      "24": {
        start: {
          line: 58,
          column: 26
        },
        end: {
          line: 58,
          column: 66
        }
      },
      "25": {
        start: {
          line: 59,
          column: 6
        },
        end: {
          line: 66,
          column: 8
        }
      },
      "26": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 71,
          column: 5
        }
      },
      "27": {
        start: {
          line: 70,
          column: 6
        },
        end: {
          line: 70,
          column: 81
        }
      },
      "28": {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 73,
          column: 21
        }
      },
      "29": {
        start: {
          line: 77,
          column: 0
        },
        end: {
          line: 92,
          column: 2
        }
      },
      "30": {
        start: {
          line: 94,
          column: 30
        },
        end: {
          line: 94,
          column: 53
        }
      }
    },
    fnMap: {
      "0": {
        name: "withRepositoryComponent",
        decl: {
          start: {
            line: 9,
            column: 9
          },
          end: {
            line: 9,
            column: 32
          }
        },
        loc: {
          start: {
            line: 9,
            column: 44
          },
          end: {
            line: 75,
            column: 1
          }
        },
        line: 9
      },
      "1": {
        name: "RepositoryComponent",
        decl: {
          start: {
            line: 10,
            column: 18
          },
          end: {
            line: 10,
            column: 37
          }
        },
        loc: {
          start: {
            line: 14,
            column: 5
          },
          end: {
            line: 74,
            column: 3
          }
        },
        line: 14
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 34,
            column: 26
          },
          end: {
            line: 34,
            column: 27
          }
        },
        loc: {
          start: {
            line: 34,
            column: 33
          },
          end: {
            line: 34,
            column: 84
          }
        },
        line: 34
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 36,
            column: 29
          },
          end: {
            line: 36,
            column: 30
          }
        },
        loc: {
          start: {
            line: 36,
            column: 40
          },
          end: {
            line: 44,
            column: 5
          }
        },
        line: 36
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 22,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 22,
            column: 5
          }
        }, {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 22,
            column: 5
          }
        }],
        line: 19
      },
      "1": {
        loc: {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 25,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 25,
            column: 5
          }
        }, {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 25,
            column: 5
          }
        }],
        line: 23
      },
      "2": {
        loc: {
          start: {
            line: 23,
            column: 8
          },
          end: {
            line: 23,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 23,
            column: 8
          },
          end: {
            line: 23,
            column: 22
          }
        }, {
          start: {
            line: 23,
            column: 26
          },
          end: {
            line: 23,
            column: 47
          }
        }],
        line: 23
      },
      "3": {
        loc: {
          start: {
            line: 34,
            column: 33
          },
          end: {
            line: 34,
            column: 84
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 34,
            column: 33
          },
          end: {
            line: 34,
            column: 37
          }
        }, {
          start: {
            line: 34,
            column: 41
          },
          end: {
            line: 34,
            column: 50
          }
        }, {
          start: {
            line: 34,
            column: 54
          },
          end: {
            line: 34,
            column: 64
          }
        }, {
          start: {
            line: 34,
            column: 68
          },
          end: {
            line: 34,
            column: 84
          }
        }],
        line: 34
      },
      "4": {
        loc: {
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 41,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 41,
            column: 7
          }
        }, {
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 41,
            column: 7
          }
        }],
        line: 38
      },
      "5": {
        loc: {
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 43,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 43,
            column: 27
          }
        }, {
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 43,
            column: 27
          }
        }],
        line: 42
      },
      "6": {
        loc: {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 67,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 67,
            column: 5
          }
        }, {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 67,
            column: 5
          }
        }],
        line: 47
      },
      "7": {
        loc: {
          start: {
            line: 47,
            column: 8
          },
          end: {
            line: 47,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 47,
            column: 8
          },
          end: {
            line: 47,
            column: 24
          }
        }, {
          start: {
            line: 47,
            column: 29
          },
          end: {
            line: 47,
            column: 33
          }
        }, {
          start: {
            line: 47,
            column: 37
          },
          end: {
            line: 47,
            column: 49
          }
        }],
        line: 47
      },
      "8": {
        loc: {
          start: {
            line: 56,
            column: 11
          },
          end: {
            line: 67,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 11
          },
          end: {
            line: 67,
            column: 5
          }
        }, {
          start: {
            line: 56,
            column: 11
          },
          end: {
            line: 67,
            column: 5
          }
        }],
        line: 56
      },
      "9": {
        loc: {
          start: {
            line: 56,
            column: 15
          },
          end: {
            line: 56,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 56,
            column: 15
          },
          end: {
            line: 56,
            column: 31
          }
        }, {
          start: {
            line: 56,
            column: 35
          },
          end: {
            line: 56,
            column: 41
          }
        }],
        line: 56
      },
      "10": {
        loc: {
          start: {
            line: 58,
            column: 6
          },
          end: {
            line: 58,
            column: 66
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 58,
            column: 6
          },
          end: {
            line: 58,
            column: 66
          }
        }, {
          start: {
            line: 58,
            column: 6
          },
          end: {
            line: 58,
            column: 66
          }
        }],
        line: 58
      },
      "11": {
        loc: {
          start: {
            line: 61,
            column: 24
          },
          end: {
            line: 61,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 61,
            column: 24
          },
          end: {
            line: 61,
            column: 36
          }
        }, {
          start: {
            line: 61,
            column: 40
          },
          end: {
            line: 61,
            column: 48
          }
        }],
        line: 61
      },
      "12": {
        loc: {
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 71,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 71,
            column: 5
          }
        }, {
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 71,
            column: 5
          }
        }],
        line: 69
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0, 0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "a6af38ee6a74acfca5fc52b67fe3b91158ec262f"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withRepository = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("../");

var _Repository = require("./Repository");

var _helpers = require("./helpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function withRepositoryComponent(Component) {
  cov_7ibe2bkbp.f[0]++;
  cov_7ibe2bkbp.s[0]++;
  return function RepositoryComponent(_ref) {
    var repository = _ref.repository,
        onRepository = _ref.onRepository,
        props = _objectWithoutProperties(_ref, ["repository", "onRepository"]);

    cov_7ibe2bkbp.f[1]++;

    var _ref2 = (cov_7ibe2bkbp.s[1]++, (0, _react.useState)(repository)),
        _ref3 = _slicedToArray(_ref2, 2),
        repo = _ref3[0],
        setRepo = _ref3[1];

    var _ref4 = (cov_7ibe2bkbp.s[2]++, props),
        authentication = _ref4.authentication;

    var repositoryConfig = (cov_7ibe2bkbp.s[3]++, {});
    cov_7ibe2bkbp.s[4]++;

    if (props.repositoryConfig) {
      cov_7ibe2bkbp.b[0][0]++;

      var _ref5 = (cov_7ibe2bkbp.s[5]++, props.repositoryConfig),
          _repositories = _ref5.repositories,
          _urls = _ref5.urls,
          _defaultOwner = _ref5.defaultOwner,
          _defaultQuery = _ref5.defaultQuery,
          _config = _objectWithoutProperties(_ref5, ["repositories", "urls", "defaultOwner", "defaultQuery"]);

      cov_7ibe2bkbp.s[6]++;
      repositoryConfig = {
        repositories: _repositories,
        urls: _urls,
        defaultOwner: _defaultOwner,
        defaultQuery: _defaultQuery,
        config: _config
      };
    } else {
      cov_7ibe2bkbp.b[0][1]++;
    }

    cov_7ibe2bkbp.s[7]++;

    if ((cov_7ibe2bkbp.b[2][0]++, authentication) && (cov_7ibe2bkbp.b[2][1]++, authentication.config)) {
      cov_7ibe2bkbp.b[1][0]++;
      cov_7ibe2bkbp.s[8]++;
      repositoryConfig.config = _objectSpread({}, repositoryConfig.config, {}, authentication.config);
    } else {
      cov_7ibe2bkbp.b[1][1]++;
    }

    var _ref6 = (cov_7ibe2bkbp.s[9]++, repositoryConfig),
        repositories = _ref6.repositories,
        urls = _ref6.urls,
        defaultOwner = _ref6.defaultOwner,
        defaultQuery = _ref6.defaultQuery,
        config = _ref6.config;

    cov_7ibe2bkbp.s[10]++;

    var hasRepository = function hasRepository() {
      cov_7ibe2bkbp.f[2]++;
      cov_7ibe2bkbp.s[11]++;
      return (cov_7ibe2bkbp.b[3][0]++, repo) && (cov_7ibe2bkbp.b[3][1]++, repo.name) && (cov_7ibe2bkbp.b[3][2]++, repo.owner) && (cov_7ibe2bkbp.b[3][3]++, repo.permissions);
    };

    cov_7ibe2bkbp.s[12]++;

    var updateRepository = function updateRepository(_repo) {
      cov_7ibe2bkbp.f[3]++;

      var __repo;

      cov_7ibe2bkbp.s[13]++;

      if (_repo) {
        cov_7ibe2bkbp.b[4][0]++;
        cov_7ibe2bkbp.s[14]++;
        __repo = _objectSpread({}, _repo);
        cov_7ibe2bkbp.s[15]++;
        __repo = (0, _helpers.extendRepository)({
          repository: __repo,
          authentication: authentication,
          updateRepository: updateRepository,
          config: config
        });
      } else {
        cov_7ibe2bkbp.b[4][1]++;
      }

      cov_7ibe2bkbp.s[16]++;

      if (onRepository) {
        cov_7ibe2bkbp.b[5][0]++;
        cov_7ibe2bkbp.s[17]++;
        onRepository(__repo);
      } else {
        cov_7ibe2bkbp.b[5][1]++;
        cov_7ibe2bkbp.s[18]++;
        setRepo(__repo);
      }
    };

    var component = (cov_7ibe2bkbp.s[19]++, _react.default.createElement("div", null));
    cov_7ibe2bkbp.s[20]++;

    if ((cov_7ibe2bkbp.b[7][0]++, !hasRepository()) && ((cov_7ibe2bkbp.b[7][1]++, urls) || (cov_7ibe2bkbp.b[7][2]++, repositories))) {
      cov_7ibe2bkbp.b[6][0]++;
      cov_7ibe2bkbp.s[21]++;
      component = _react.default.createElement(_.Repositories, {
        urls: urls,
        repositories: repositories,
        onRepository: updateRepository,
        config: config
      });
    } else {
      cov_7ibe2bkbp.b[6][1]++;
      cov_7ibe2bkbp.s[22]++;

      if ((cov_7ibe2bkbp.b[9][0]++, !hasRepository()) && (cov_7ibe2bkbp.b[9][1]++, config)) {
        cov_7ibe2bkbp.b[8][0]++;
        var username;
        cov_7ibe2bkbp.s[23]++;

        if (authentication) {
          cov_7ibe2bkbp.b[10][0]++;
          cov_7ibe2bkbp.s[24]++;
          username = authentication.user.username;
        } else {
          cov_7ibe2bkbp.b[10][1]++;
        }

        cov_7ibe2bkbp.s[25]++;
        component = _react.default.createElement(_.Search, {
          defaultOwner: (cov_7ibe2bkbp.b[11][0]++, defaultOwner) || (cov_7ibe2bkbp.b[11][1]++, username),
          defaultQuery: defaultQuery,
          onRepository: updateRepository,
          config: config
        });
      } else {
        cov_7ibe2bkbp.b[8][1]++;
      }
    }

    cov_7ibe2bkbp.s[26]++;

    if (hasRepository()) {
      cov_7ibe2bkbp.b[12][0]++;
      cov_7ibe2bkbp.s[27]++;
      component = _react.default.createElement(Component, _extends({}, props, {
        repository: repo,
        blobConfig: config
      }));
    } else {
      cov_7ibe2bkbp.b[12][1]++;
    }

    cov_7ibe2bkbp.s[28]++;
    return component;
  };
}

cov_7ibe2bkbp.s[29]++;
withRepositoryComponent.propTypes = _objectSpread({
  /** Configuration to pass through to the Search/Repositories component. */
  repositoryConfig: _propTypes.default.shape({
    /** Urls array to get repository data, if repository data is not provided. */
    urls: _propTypes.default.array,

    /** Repositories data array to render, if urls not provided. */
    repositories: _propTypes.default.array,

    /** Prefill the owner search field. */
    defaultOwner: _propTypes.default.string,

    /** Prefill the query search field. */
    defaultQuery: _propTypes.default.string,

    /** Configuration required for Search or Repositories if paths are provided as URL. */
    server: _propTypes.default.string
  }).isRequired
}, _Repository.Repository.propTypes);
var withRepository = (cov_7ibe2bkbp.s[30]++, withRepositoryComponent);
exports.withRepository = withRepository;